/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.querySelectorAll(".glb_mute").forEach((btn) => {
    btn.addEventListener("click", function () {
      const parentDiv = btn.parentElement; // find nearest parent div
      const currentVideo = parentDiv.querySelector("video");
      if (currentVideo && !currentVideo.paused) {
        document.querySelectorAll(".off_sound_global, .video_selector").forEach((wrapper) => {
          const video = wrapper.querySelector("video");
          const playBtn = wrapper.querySelector('.glb_play');
          const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
          if (video !== currentVideo && !video.paused) {
            video.muted = true;
            //video.pause();
            const parentDivELe = video.parentElement;
            const muteBtn = parentDivELe.querySelector(".glb_mute");
            if (muteBtn) {
              muteBtn.classList.add("muted");
            }
          }
        });
      }
    });
  });
 function offsoundAllVideos(currentWrapper = null) {
  const isMobile = window.innerWidth <= 767;
  const allOtherVideos = document.querySelectorAll('.off_sound_global');

  allOtherVideos.forEach((wrapper) => {
    // Skip the current (active) video
    if (currentWrapper && wrapper === currentWrapper) return;

    const video = wrapper.querySelector("video");
    const playBtn = wrapper.querySelector('.glb_play');
    const posterWrapper = wrapper.querySelector(".custom-poster-wrapper");
    const muteBtn = wrapper.querySelector(".glb_mute");

    if (!video) return;

    // Pause and mute all other videos
    video.pause();
    video.muted = true;

    // Reset UI states
    playBtn?.classList.remove('playing');
    if (posterWrapper) posterWrapper.style.opacity = 1;
    if (muteBtn) muteBtn.classList.add('muted');
  });
}



  function initCustomVideoPlayerWithHLS(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;

    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.video_selector');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const shouldAutoplay = () => (isMobile ? video.dataset.autoplayM : video.dataset.autoplay) === 'true';
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

            


      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster layer
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      // Setup video
      var mtp = false;
      video.removeAttribute('muted');
      if( shouldAutoplay() )
      {
        var mtp = true;
        video.setAttribute('muted', '');
        
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      
      video.muted = mtp;

      function safePlay() {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(() => {
              playBtn?.classList.add('playing');
              
            })
            .catch(() => {
              playBtn?.classList.remove('playing');
              if (posterWrapper) posterWrapper.style.opacity = 1;
            });
        }
      }

      video.addEventListener('playing', () => {
        // Hide poster only when video is actually rendering
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });


      function pauseVideo( otherVideo = null, vWrapper = null ) {
        if( otherVideo )
        {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        }
        else{
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if( autoplay && video )
        {
          video.muted = true;
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
        }
        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';
        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              if (autoplay) safePlay();
            }, { once: true });
          } 
          else 
          {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({ 
                  maxBufferLength: 3,
                  startLevel: -1,      
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  if (autoplay) safePlay();
                });
              }
            })
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
        //playBtn?.style.setProperty('display', autoplay ? 'none' : 'block');
        //if (posterWrapper) posterWrapper.style.opacity = autoplay ? 0 : 1;
      }

      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.video_selector');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);
          
          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos(wrapper);
          safePlay();
          video.muted = false;
          if (muteBtn) {
            muteBtn.classList.remove('muted');
          }
        } else {
          if (muteBtn) {
            muteBtn.classList.add('muted');
          }
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  document.querySelectorAll(".init_hls_video").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomVideoPlayerWithHLS(sectionID);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".init_hls_video");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomVideoPlayerWithHLS(sectionID);
    }
  });



  function safePlayUsingFlickity( section, videoWrapper )
  {
    offsoundAllVideos(videoWrapper);
    const playBtn = videoWrapper.querySelector('.glb_play');
    const video = videoWrapper.querySelector('video');
    const videoPoster = videoWrapper.querySelector(".custom-poster-wrapper");

    const carousel = section.querySelector('.customer-love-it__slider');
    const flkty = window.theme.Flickity.data(carousel);
    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => {
        playBtn?.classList.add('playing');
        video.onended = () => {
          video.pause();
          playBtn?.classList.remove('playing');
          if (videoPoster) videoPoster.style.opacity = 1;
          if (flkty) flkty.next();
        };
      })
      .catch(() => {
        playBtn?.classList.remove('playing');
        if (videoPoster) videoPoster.style.opacity = 1;
      });
    }
  }
  function initCustomerLoverItHlsVideo(sectionId) {
    let thresholdValue = 0.2;
    setTimeout(() => {
      thresholdValue = 0.6;
    }, 7000);

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const videoAutoplay = section.dataset.videoAutoplay === "true";

    const videoWrappers = section.querySelectorAll('.customer_love_it_video');
    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    // ✅ Progress bar helper
    function attachVideoProgress(video, wrapper) {
      let progressBar = wrapper.querySelector('.video-progress-bar');
      if (!progressBar) {
        progressBar = document.createElement('div');
        progressBar.className = 'video-progress-bar';
        Object.assign(progressBar.style, {
          position: 'absolute',
          bottom: '10px',
          left: '10px',
          width: 'calc(100% - 20px)',
          height: '4px',
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '2px',
          overflow: 'hidden',
          zIndex: 3,
        });

        const progressFill = document.createElement('div');
        progressFill.className = 'video-progress-fill';
        Object.assign(progressFill.style, {
          width: '0%',
          height: '100%',
          background: '#fff',
          transition: 'width 0.2s linear',
        });

        progressBar.appendChild(progressFill);
        wrapper.appendChild(progressBar);
      }

      const progressFill = progressBar.querySelector('.video-progress-fill');
      let rafId = null;

      function updateProgress() {
        if (!video.paused && !video.ended && video.duration > 0) {
          const percent = (video.currentTime / video.duration) * 100;
          progressFill.style.width = `${percent}%`;
          rafId = requestAnimationFrame(updateProgress);
        }
      }

      video.addEventListener('play', () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(updateProgress);
      });

      video.addEventListener('pause', () => {
        cancelAnimationFrame(rafId);
      });

      video.addEventListener('ended', () => {
        cancelAnimationFrame(rafId);
        progressFill.style.width = '0%';
      });

      video.addEventListener('loadedmetadata', () => {
        progressFill.style.width = '0%';
      });
    }

    // Loop through all videos
    videoWrappers.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      if (!video || video.dataset.initialized === 'true') return;
      video.dataset.initialized = 'true';

      const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
      const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      const showMute = (isMobile ? video.dataset.muteM : video.dataset.mute) === 'true';
      const showFullscreen = (isMobile ? video.dataset.fullscreenM : video.dataset.fullscreen) === 'true';

      const playBtn = wrapper.querySelector('.glb_play');
      const muteBtn = wrapper.querySelector('.glb_mute');
      const fullscreenBtn = wrapper.querySelector('.glb_fullscreen');

      const shouldAutoplay = () => (wrapper.closest('div.carousel-cell.is-selected'));

      let hls = null;
      let isNativeHLS = false;
      let isVideoLoaded = false;

      // Poster setup
      const posterUrl = getPoster();
      const posterWrapper = document.createElement('picture');
      posterWrapper.className = 'custom-poster-wrapper';
      Object.assign(posterWrapper.style, {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        background: `url('${posterUrl}') center center / cover no-repeat`,
        pointerEvents: 'none',
        transition: 'opacity 0.4s ease',
        opacity: 1
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(posterWrapper);
      video._posterWrapper = posterWrapper;

      var mtp = true;
      video.removeAttribute('muted');
      if (shouldAutoplay()) {
        var mtp = true;
        video.setAttribute('muted', '');
      }
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.muted = mtp;

      function safePlay() {
        const carousel = section.querySelector('.customer-love-it__slider');
        const flkty = window.theme.Flickity.data(carousel);
        if (!flkty) return;
        const parentCell = video.closest('.carousel-cell');
        if (parentCell && !parentCell.classList.contains('is-selected')) {
          const cellIndex = flkty.cells.findIndex(cell => cell.element === parentCell);
          if (cellIndex >= 0) flkty.select(cellIndex);
        }

        setTimeout(() => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                playBtn?.classList.add('playing');
                video.onended = () => {
                  video.pause();
                  playBtn?.classList.remove('playing');
                  if (posterWrapper) posterWrapper.style.opacity = 1;
                  if (flkty) flkty.next();
                };
              })
              .catch(() => {
                playBtn?.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
          }
        }, 0);
      }

      video.addEventListener('playing', () => {
        if (posterWrapper) posterWrapper.style.opacity = 0;
      });

      function pauseVideo(otherVideo = null, vWrapper = null) {
        if (otherVideo) {
          otherVideo.pause();
          let otherPlayBtn = vWrapper.querySelector('.glb_play');
          otherPlayBtn?.classList.remove('playing');
          let otherPosterWrapper = vWrapper.querySelector('.custom-poster-wrapper');
          if (otherPosterWrapper) otherPosterWrapper.style.opacity = 1;
        } else {
          video.pause();
          playBtn?.classList.remove('playing');
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }
      }

      function loadVideo() {
        const src = getSrc();
        var autoplay = shouldAutoplay();

        if (autoplay && video) {
          video.muted = true;
          if (muteBtn) muteBtn.classList.add('muted');
        }

        if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
          if (autoplay) safePlay();
          return;
        }

        video.setAttribute('data-loaded-src', src);
        isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';

        if (src.endsWith('.m3u8')) {
          if (isNativeHLS) {
            video.src = src;
            video.setAttribute('preload', 'auto');
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', () => {
              attachVideoProgress(video, wrapper); // ✅ attach progress bar
              if (autoplay) safePlay();
            }, { once: true });
          } else {
            loadHlsJs(() => {
              if (window.Hls && Hls.isSupported()) {
                hls = new Hls({
                  maxBufferLength: 3,
                  startLevel: -1,
                  capLevelToPlayerSize: true
                });
                hls.loadSource(src);
                hls.attachMedia(video);
                video.hlsInstance = hls;

                hls.on(Hls.Events.MANIFEST_PARSED, () => {
                  isVideoLoaded = true;
                  attachVideoProgress(video, wrapper); // ✅ attach progress bar
                  if (autoplay) safePlay();
                });
              }
            });
          }
        } else {
          const source = document.createElement('source');
          source.src = src;
          source.type = 'video/mp4';
          video.appendChild(source);
          video.load();
          isVideoLoaded = true;
          video.addEventListener('loadedmetadata', () => {
            attachVideoProgress(video, wrapper); // ✅ attach progress bar
            if (autoplay) safePlay();
          }, { once: true });
        }

        playBtn?.classList.toggle('playing', autoplay);
      }

      // Observer logic
      function isVisible(entry, wrap) {
        const rect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;
        const visibleRatio = intersection.width / rect.width;
        return visibleRatio >= thresholdValue && entry.isIntersecting;
      }

      function isOutOfView(el) {
        const rect = el.getBoundingClientRect();
        return (
          rect.bottom < 0 ||
          rect.top > window.innerHeight ||
          rect.right < 0 ||
          rect.left > window.innerWidth
        );
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wrap = entry.target.closest('.customer_love_it_video');
          if (!wrap) return;
          const shouldPlay = isVisible(entry, wrap) && !isOutOfView(wrap);

          if (shouldPlay) {
            loadVideo();
          } else {
            pauseVideo();
          }
        });
      }, {
        threshold: Array.from({ length: 21 }, (_, i) => i / 20),
      });

      observer.observe(video);

      // Controls
      playBtn?.addEventListener('click', () => {
        if (video.paused) {
          offsoundAllVideos(wrapper);
          safePlay();
          video.muted = false;
          if (muteBtn) muteBtn.classList.remove('muted');
        } else {
          if (muteBtn) muteBtn.classList.add('muted');
          pauseVideo();
        }
      });

      if (muteBtn) {
        muteBtn.style.display = showMute ? 'block' : 'none';
        muteBtn.classList.toggle('muted', video.muted);
        muteBtn.addEventListener('click', () => {
          video.muted = !video.muted;
          muteBtn.classList.toggle('muted', video.muted);
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.style.display = showFullscreen ? 'block' : 'none';
        fullscreenBtn.addEventListener('click', () => {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
        });
      }
    });
  }

  function initCustomerLoverItSlider(section) {
    
    const slider = section.querySelector(".customer-love-it__slider");
    const desktop  = parseInt(slider.dataset.slidesDesktop) || 3;
    const tablet   = parseInt(slider.dataset.slidesTablet)  || 2;
    const mobile   = parseInt(slider.dataset.slidesMobile)  || 1;
    const autoPlay = false;
    const nav   = slider.dataset.showNav == "true";
    const totalSlides = slider.querySelectorAll(".carousel-cell").length;

    function alignment(){
      if (window.innerWidth > 1024) return 'center';
      if (window.innerWidth >= 768)  return 'center';
      return 'left';
    }
    function getGroupCells(){
      if (window.innerWidth > 1024) return desktop;
      if (window.innerWidth >= 768)  return tablet;
      return mobile;
    }
    function getOptions() {
      const slidesToShow = getGroupCells();
      const contain_v = totalSlides <= slidesToShow;
      const wrap_v    = totalSlides > slidesToShow;
      var truenav = false
      if( nav && wrap_v ){
        truenav = true; 
      }
      return {
        cellAlign: alignment(),
        contain: contain_v,
        imagesLoaded: true,
        wrapAround: wrap_v,
        autoPlay: autoPlay > 0 ? autoPlay : false,
        prevNextButtons: truenav,
        pageDots: false,
        draggable: wrap_v,
        touchVerticalScroll: false,
        adaptiveHeight: false,
      };
    }

    // init Flickity
    let flkty = new window.theme.Flickity(slider, getOptions());

    // reinit on resize if breakpoint changes
    let lastSlidesToShow = getGroupCells();
    let lastAlign = alignment();


    window.addEventListener("resize", () => {
      const newSlidesToShow = getGroupCells();
      const newAlign = alignment();

      if (newSlidesToShow !== lastSlidesToShow || newAlign !== lastAlign) {
        flkty.destroy();
        flkty = new window.theme.Flickity(slider, getOptions());
        lastSlidesToShow = newSlidesToShow;
        lastAlign = newAlign;
      } else {
        flkty.resize();
      }
    });

    flkty.on('settle', () => {
      const currentCell = flkty.selectedElement;
      const video_wrapper = currentCell?.querySelector('.customer_love_it_video');
      if (video_wrapper) {
        safePlayUsingFlickity(section, video_wrapper);
      }
    });
  }
  document.querySelectorAll(".customer-love-it").forEach(section => {
    const sectionID = section.getAttribute('data-section-id');
    initCustomerLoverItHlsVideo(sectionID);
    initCustomerLoverItSlider(section);
  });
  document.addEventListener("shopify:section:load", function(event) {
    const section = event.target.querySelector(".customer-love-it");
    if (section) {
      const sectionID = section.getAttribute('data-section-id');
      initCustomerLoverItHlsVideo(sectionID);
      initCustomerLoverItSlider(section);
    }
  });
  
  // 🔧 Customizer events
  document.addEventListener("shopify:section:load", (e) => {
    const section = e.target;
    if (section.classList.contains("customer-love-it")) {
      initCustomerLoveIt(section);
    }
  });

  /* FOR HOVER VIDEOS */
  function initHoverHlsVideo(sectionId) {
    const sections = document.querySelectorAll(`[data-section-id="${sectionId}"]`);
    if (!sections.length) return;

    const isMobile = window.innerWidth <= 767;

    function loadHlsJs(callback) {
      if (window.Hls) {
        callback();
        return;
      }
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/hls.js@latest";
      script.onload = () => callback();
      document.head.appendChild(script);
    }

    sections.forEach((section) => {
      const videoWrappers = section.querySelectorAll('.hover-video-selector');

      videoWrappers.forEach((wrapper) => {
        const video = wrapper.querySelector('video[data-desktop-video], video[data-mobile-video]');
        if (!video) return;
        // Guard on wrapper binding state, not on copied video attributes.
        // Cloned nodes may preserve data attributes but lose event listeners.
        if (wrapper.__hoverVideoBound) return;
        wrapper.__hoverVideoBound = true;
        video.__hoverVideoInit = true;

        const getSrc = () => isMobile ? video.dataset.mobileVideo : video.dataset.desktopVideo;
        const getPoster = () => isMobile ? video.dataset.mobilePoster : video.dataset.desktopPoster;

        let hls = null;
        let isNativeHLS = false;
        let isVideoLoaded = false;

      // Create and display poster
        const posterUrl = getPoster();
        const posterWrapper = document.createElement('picture');
        posterWrapper.className = 'custom-poster-wrapper';
        Object.assign(posterWrapper.style, {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
          //background: `url('${posterUrl}') center center / cover no-repeat`,
          pointerEvents: 'none',
          transition: 'opacity 0.4s ease',
          opacity: 1
        });

        const innerWrapper = wrapper.querySelector('.video_selector') || wrapper;
        innerWrapper.appendChild(posterWrapper);

        video._posterWrapper = posterWrapper;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('preload', 'metadata');

      // Helper: Play safely
        function safePlay() {
          // Hover previews should always be silent to avoid autoplay blocking.
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise
              .then(() => {
                video.classList.add('playing');
                if (posterWrapper) posterWrapper.style.opacity = 0;
              })
              .catch(() => {
                video.classList.remove('playing');
                if (posterWrapper) posterWrapper.style.opacity = 1;
              });
          }
        }

      // Helper: Pause
        function pauseVideo() {
          video.pause();
          if (posterWrapper) posterWrapper.style.opacity = 1;
        }

      // Load video on hover
        function loadVideo() {
          const rawSrc = getSrc();
          const src = rawSrc && rawSrc.startsWith('//') ? `${window.location.protocol}${rawSrc}` : rawSrc;
          if (!src) return;

          if (isVideoLoaded && video.getAttribute('data-loaded-src') === src) {
            safePlay();
            return;
          }

          video.setAttribute('data-loaded-src', src);
          isNativeHLS = src.endsWith('.m3u8') && video.canPlayType('application/vnd.apple.mpegurl') !== '';

          if (src.endsWith('.m3u8')) {
            if (isNativeHLS) {
              video.src = src;
              video.setAttribute('preload', 'auto');
              video.load();
              isVideoLoaded = true;
              video.addEventListener('loadedmetadata', safePlay, { once: true });
              video.addEventListener('canplay', safePlay, { once: true });
            } else {
              loadHlsJs(() => {
                if (window.Hls && Hls.isSupported()) {
                  hls = new Hls({ 
                    maxBufferLength: 3,
                    startLevel: -1,      
                    capLevelToPlayerSize: true
                  });
                  hls.loadSource(src);
                  hls.attachMedia(video);
                  video.hlsInstance = hls;

                  hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                    video.setAttribute('preload', 'auto');
                  });
                  hls.on(Hls.Events.MANIFEST_PARSED, () => {
                    isVideoLoaded = true;
                    safePlay();
                  });
                  hls.on(Hls.Events.LEVEL_LOADED, () => {
                    isVideoLoaded = true;
                    safePlay();
                  });
                  hls.on(Hls.Events.ERROR, (_event, data) => {
                    if (!data || !data.fatal) return;
                    if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                      try { hls.recoverMediaError(); } catch (e) {}
                      return;
                    }
                    try { hls.destroy(); } catch (e) {}
                    hls = null;
                    video.src = src;
                    video.load();
                    video.addEventListener('canplay', safePlay, { once: true });
                  });
                  video.addEventListener('canplay', safePlay, { once: true });
                }
              });
            }
          } else {
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);
            video.load();
            isVideoLoaded = true;
            video.addEventListener('loadedmetadata', safePlay, { once: true });
          }
        }

        if (!isMobile) {
          // Desktop behavior: play on hover
          wrapper.addEventListener('mouseenter', loadVideo);
          wrapper.addEventListener('mouseleave', pauseVideo);
        } else {
          // Mobile behavior: play when card is in view, pause when it leaves viewport
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
                loadVideo();
              } else {
                pauseVideo();
              }
            });
          }, {
            threshold: [0, 0.45, 0.75, 1]
          });

          observer.observe(wrapper);
          video._hoverVideoObserver = observer;

          // Optional manual trigger for tap-first interaction
          wrapper.addEventListener('touchstart', () => {
            loadVideo();
          }, { passive: true });
        }
      });
    });
  }
  function initHoverVideoSections(root = document) {
    const sectionIds = new Set();

    if (root && root.nodeType === 1 && root.matches && root.matches('[data-section-id]')) {
      const ownId = root.getAttribute('data-section-id');
      if (ownId) sectionIds.add(ownId);
    }

    const sectionCandidates = root.querySelectorAll ? root.querySelectorAll('[data-section-id]') : [];
    sectionCandidates.forEach((section) => {
      const sectionID = section.getAttribute('data-section-id');
      if (sectionID) sectionIds.add(sectionID);
    });

    sectionIds.forEach((sectionID) => initHoverHlsVideo(sectionID));
  }

  function observeHoverVideoInjection() {
    if (!document.body || window.__hoverVideoObserverBound) return;
    window.__hoverVideoObserverBound = true;

    const observer = new MutationObserver((mutations) => {
      let shouldInit = false;

      for (const mutation of mutations) {
        if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

        for (const node of mutation.addedNodes) {
          if (!node || node.nodeType !== 1) continue;

          if (
            (node.matches && (node.matches('.hover-video-selector') || node.matches('[data-section-id]'))) ||
            (node.querySelector && node.querySelector('.hover-video-selector'))
          ) {
            shouldInit = true;
            break;
          }
        }

        if (shouldInit) break;
      }

      if (!shouldInit) return;

      clearTimeout(window.__hoverVideoInitTimer);
      window.__hoverVideoInitTimer = setTimeout(() => {
        initHoverVideoSections();
      }, 60);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initHoverVideoSections();
    observeHoverVideoInjection();
  });
  document.addEventListener("shopify:load", () => initHoverVideoSections());

  
  // Listen for when recently viewed products are loaded
  document.addEventListener('related:loaded', function(event) {
      const sections = document.querySelectorAll('.init_hls_videos_when_loaded');
      sections.forEach((section) => {
        const sectionID = section.getAttribute('data-section-id');
        initHoverHlsVideo(sectionID);
      });
      
      
      
      // Access the recently viewed container
      // const recentlyViewedContainer = event.target;
      // const products = recentlyViewedContainer.querySelectorAll('.product-item');
      
      // console.log(`Found ${products.length} recently viewed products`);
  });

  



})();

(function () {
  'use strict';

  function getNotifyMap(form) {
    if (!form) return null;
    var script = form.querySelector('[data-notify-variant-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function updateNotifyStateForSection(sectionEl, variantId) {
    if (!sectionEl || !variantId) return;

    var form = sectionEl.querySelector('form[data-product-form]');
    if (!form) return;

    var notifyMap = getNotifyMap(form);
    if (!notifyMap) return;

    var notifyBtn = sectionEl.querySelector('[data-notify-button]');
    var addBtn = sectionEl.querySelector('[data-main-atc-button]');
    var hideWhenNotify = sectionEl.querySelectorAll('[data-notify-hide-when-active]');

    if (!notifyBtn || !addBtn) return;

    var notifyActive = Boolean(notifyMap[String(variantId)]);

    notifyBtn.setAttribute('data-variant-id', String(variantId));
    notifyBtn.style.display = notifyActive ? '' : 'none';

    addBtn.style.display = notifyActive ? 'none' : '';
    if (notifyActive) {
      addBtn.setAttribute('disabled', 'disabled');
    }

    hideWhenNotify.forEach(function (el) {
      el.style.display = notifyActive ? 'none' : '';
    });
  }

  function updateNotifyStateFromEvent(payload) {
    if (!payload || !payload.data || !payload.data.variant) return;

    var sectionId = payload.data.sectionId;
    var variantId = payload.data.variant.id;
    if (!sectionId || !variantId) return;

    var sectionEl = document.querySelector('product-info[data-section="' + sectionId + '"]') ||
      document.querySelector('product-info[data-original-section="' + sectionId + '"]') ||
      document.querySelector('product-info[data-section-id="' + sectionId + '"]') ||
      document.querySelector('product-info');

    updateNotifyStateForSection(sectionEl, variantId);
  }

  function initNotifyState() {
    document.querySelectorAll('product-info').forEach(function (sectionEl) {
      var form = sectionEl.querySelector('form[data-product-form]');
      if (!form) return;
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) return;
      updateNotifyStateForSection(sectionEl, variantInput.value);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNotifyState();

    if (typeof subscribe === 'function' && window.theme && theme.PUB_SUB_EVENTS) {
      subscribe(theme.PUB_SUB_EVENTS.variantChange, function (payload) {
        updateNotifyStateFromEvent(payload);
      });
    }
  });
})();

(function () {
  'use strict';

  function safePlayVideo(video) {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function getGalleryFromHost(host) {
    if (!host) return null;
    if (host.matches && host.matches('zoom-images[data-product-media-list]')) return host;
    return host.querySelector ? host.querySelector('zoom-images[data-product-media-list]') : null;
  }

  function getActiveSlide(gallery, host) {
    if (!gallery) return null;

    const activeId =
      (host && host.getAttribute && host.getAttribute('data-active-media')) ||
      gallery.getAttribute('data-active-media');

    if (activeId) {
      const byId = gallery.querySelector('[data-slide][data-media-id="' + activeId + '"]');
      if (byId) return byId;
    }

    return gallery.querySelector('[data-slide].media--active');
  }

  function syncActiveGalleryVideo(host) {
    const gallery = getGalleryFromHost(host);
    if (!gallery) return;

    const activeSlide = getActiveSlide(gallery, host);
    if (!activeSlide) return;

    const allVideos = gallery.querySelectorAll('[data-slide][data-type="video"] video.media-video');
    allVideos.forEach(function (video) {
      const isActive = activeSlide.contains(video);
      if (isActive) {
        safePlayVideo(video);
      } else {
        try { video.pause(); } catch (e) {}
      }
    });
  }

  function bindHost(host) {
    if (!host || host.__galleryVideoSyncBound) return;
    host.__galleryVideoSyncBound = true;

    const runSync = function () {
      clearTimeout(host.__galleryVideoSyncTimer);
      host.__galleryVideoSyncTimer = setTimeout(function () {
        syncActiveGalleryVideo(host);
      }, 30);
    };

    runSync();

    host.addEventListener('theme:media:select', runSync);

    const hostObserver = new MutationObserver(function (mutations) {
      const changed = mutations.some(function (m) {
        return m.type === 'attributes' && m.attributeName === 'data-active-media';
      });
      if (changed) runSync();
    });
    hostObserver.observe(host, { attributes: true, attributeFilter: ['data-active-media'] });

    const gallery = getGalleryFromHost(host);
    if (gallery) {
      const galleryObserver = new MutationObserver(function (mutations) {
        const classChanged = mutations.some(function (m) {
          return m.type === 'attributes' && m.attributeName === 'class' && m.target && m.target.hasAttribute && m.target.hasAttribute('data-slide');
        });
        if (classChanged) runSync();
      });
      galleryObserver.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  function initGalleryVideoSync(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-images').forEach(bindHost);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGalleryVideoSync(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initGalleryVideoSync(event.target || document);
  });
})();

(function () {
  'use strict';

  function collapseAccordionDetails(detailsEl) {
    if (!detailsEl) return;
    detailsEl.removeAttribute('open');

    var body = detailsEl.querySelector('[data-collapsible-body]');
    if (body) {
      body.style.height = '';
    }
  }

  document.addEventListener('theme:collapsible:toggle', function (event) {
    var currentDetails = event && event.target ? event.target.closest('details[data-collapsible]') : null;
    if (!currentDetails || !currentDetails.hasAttribute('open')) return;

    var productInfo = currentDetails.closest('product-info');
    if (!productInfo) return;

    var isProductAccordion =
      currentDetails.closest('.product-accordion') ||
      currentDetails.closest('.product__fragrance-specs');

    if (!isProductAccordion) return;

    var openAccordions = productInfo.querySelectorAll(
      '.product-accordion details[data-collapsible][open], .product__fragrance-specs details[data-collapsible][open]'
    );

    openAccordions.forEach(function (detailsEl) {
      if (detailsEl !== currentDetails) {
        collapseAccordionDetails(detailsEl);
      }
    });
  });
})();

/*
 * Quick-add modal close watchdog.
 *
 * The theme's QuickAddProduct closes its dialog in two steps: setting a
 * `closing` attribute starts the CSS close animation, and the dialog's own
 * `animationend` event performs the real close + removal. When that event is
 * missed (dropped frames, backgrounded tab, some mobile browsers), the dialog
 * stays open but invisible - a full-viewport, z-index 6000 overlay that
 * swallows the next tap. That is why quick-add buttons for multi-variant
 * products could need two taps on mobile.
 *
 * This watchdog waits slightly longer than the close animation and, if the
 * dialog is still stuck in `closing` state, re-dispatches the animationend
 * event the theme is waiting for (verified to complete the close), with a
 * hard remove as last resort.
 */
(function () {
  var CLOSE_TIMEOUT = 800; // ms, longer than the drawer close animation

  function forceFinish(dialog) {
    if (!dialog.isConnected || !dialog.hasAttribute('closing')) return;

    dialog.dispatchEvent(new AnimationEvent('animationend', {animationName: 'fadeOut', bubbles: true}));

    // Last resort: still stuck, remove it so it cannot block taps.
    if (dialog.isConnected && dialog.hasAttribute('closing')) {
      if (typeof dialog.close === 'function') dialog.close();
      dialog.remove();
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    }
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var dialog = mutation.target;
      if (
        mutation.attributeName === 'closing' &&
        dialog.nodeName === 'DIALOG' &&
        dialog.hasAttribute('data-quick-add-modal') &&
        dialog.hasAttribute('closing')
      ) {
        setTimeout(function () {
          forceFinish(dialog);
        }, CLOSE_TIMEOUT);
      }
    });
  });

  if (document.body) {
    observer.observe(document.body, {attributes: true, attributeFilter: ['closing'], subtree: true});
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, {attributes: true, attributeFilter: ['closing'], subtree: true});
    });
  }
})();

/*
 * Quick-add modal button: first-tap fix for real touch devices.
 *
 * On real phones (not DevTools emulation) the first tap on a product card
 * runs the browser's hover emulation first: simulated mouseenter/mouseover
 * events fire, the card visibly changes state (hover images, swatch preview,
 * hover video), and the browser withholds the click - so opening the
 * multi-variant quick-add modal needed a second tap. Single-variant add-to-
 * cart buttons were unaffected only when their cards had no hover behavior.
 *
 * Fix: treat a clean tap on the modal button as a click at touchend time,
 * before hover emulation can swallow it. Scroll/drag gestures and long
 * presses are ignored; preventDefault() stops the browser from sending the
 * simulated mouse events afterwards, so the handler cannot run twice.
 */
(function () {
  var MOVE_TOLERANCE = 10; // px of finger travel still counting as a tap
  var MAX_TAP_MS = 700; // longer press is not a tap
  var BUTTON_SELECTOR = '[data-quick-add-btn][data-quick-add-modal-handle]';

  var startX = 0;
  var startY = 0;
  var startTime = 0;
  var tracking = false;

  document.addEventListener(
    'touchstart',
    function (event) {
      var btn = event.target.closest ? event.target.closest(BUTTON_SELECTOR) : null;
      if (!btn) {
        tracking = false;
        return;
      }
      var touch = event.changedTouches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      startTime = Date.now();
      tracking = true;
    },
    {passive: true}
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!tracking) return;
      tracking = false;

      var btn = event.target.closest ? event.target.closest(BUTTON_SELECTOR) : null;
      if (!btn || btn.disabled) return;

      var touch = event.changedTouches[0];
      if (Math.abs(touch.clientX - startX) > MOVE_TOLERANCE) return;
      if (Math.abs(touch.clientY - startY) > MOVE_TOLERANCE) return;
      if (Date.now() - startTime > MAX_TAP_MS) return;

      event.preventDefault();
      btn.click();
    },
    {passive: false}
  );
})();